import React from 'react';
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import {Snackbar} from "@material-ui/core";
import {Alert} from "@material-ui/lab";

const SingleSnackbar = (props) => {
    const {severity, handleClose, ...restProps} = props
    return <Snackbar
        {...restProps}
        autoHideDuration={6000}
        onClose={handleClose}
        style={{zIndex: 9999999999}}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'center'
        }}
        action={
            <IconButton size="small" aria-label="close" color="inherit" onClick={props.handleClose}>
                <CloseIcon fontSize="small"/>
            </IconButton>
        }
    >
        <Alert onClose={handleClose} severity={props.severity}>
            {props.message}
        </Alert>
    </Snackbar>
}
export default SingleSnackbar